import './alert-container.scss'

import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import { ReactiveVue } from '@skinsoft/reactive-vue';

import { router, Routes } from '../../../router';

@Component({
    template: require('./alert-container.html')
})
export class AlertContainer extends ReactiveVue {

    public alertMessage: string = "";
    public alertVariant: string = "";
    public show: boolean = false;

    private saveAlertTimeout = null as any;
    private readonly SAVE_ALERT_DURATION = 3000;
    private offsetBottom: boolean = false;

    public mounted() {
        this.subscribeToBus('display-alert-topic', (message) => {
            if (message.payload) {
                this.showAlert(message.payload)
            }
        })
    }

    private showAlert(alertData: any) {
        clearTimeout(this.saveAlertTimeout)
        this.show = false;
        this.alertMessage = alertData.message;
        this.alertVariant = alertData.variant;
        setTimeout(() => {
            this.show = true;
            this.saveAlertTimeout = setTimeout(() => {
                this.show = false;
            },
                this.SAVE_ALERT_DURATION)
        }, 200);
    }

    // @Watch('router.currentRoute', { deep: true })
    // private onRouteChanged() {
    //     this.offsetBottom = router.currentRoute.name === Routes.EDIT_REPORT;
    // }
}